import React from 'react';

import CloseIcon from '../../../icons/close.svg';

import styles from './CloseButton.scss';

type Props = {
  label?: string;
  onClick?: () => void;
  iconSize?: number;
};

function CloseButton(props: Props) {
  const { label = 'Close', onClick, iconSize = 24 } = props;

  return (
    <button className={styles.button} aria-label={label} onClick={onClick}>
      <CloseIcon style={{ width: iconSize, height: iconSize }} />
    </button>
  );
}

export default React.memo(CloseButton);
